import { FC } from "react";
import PageTemplate from "../PageTemplate";
import CompletedOrdersPage from "./CompletedOrdersPage";

const CompletedOrders: FC = () => {
    return <PageTemplate Page={CompletedOrdersPage} />;
};

export default CompletedOrders;
